// helix-rails.js — drives the two mid-height rails flanking the spiral.
//
// Both rails read the same number: how far the pinned .helixArea has been
// scrolled through, 0 → 1. That feeds the left meter (an accent fill plus a
// running index) and the right tick scale (one notch per piece on the ribbon).
// Deliberately independent of the WebGL path, so the rails behave the same
// whether the 3D stage booted or not.

// the ten pieces riding the ribbon, in ribbon order — the same set the FOLIO
// index lists, so both sections name a project identically
const PIECES = [
  ['ORBIT COFFEE',     'BRAND IDENTITY · 2026'],
  ['HALO FASHION',     'E-COMMERCE · 2025'],
  ['PULSE FESTIVAL',   'EVENT VISUALS · 2025'],
  ['MONO ARCHITECTS',  'DIGITAL EXPERIENCE · 2024'],
  ['KOI SKINCARE',     'BRAND REFRESH · 2024'],
  ['AURORA LABS',      'PRODUCT WEBSITE · 2026'],
  ['NOIR HOTEL',       'SPATIAL IDENTITY · 2025'],
  ['FRAME PAPER',      'EDITORIAL DESIGN · 2025'],
  ['VEIL JEWELRY',     'CAMPAIGN · 2024'],
  ['ECHO RECORDS',     'MOTION IDENTITY · 2023'],
];
const STEPS = PIECES.length;

export function initHelixRails() {
  const section = document.querySelector('[data-helix-area]');
  if (!section) return;

  const fill    = document.querySelector('[data-helix-progress]');
  const index   = document.querySelector('[data-helix-index]');
  const pct     = document.querySelector('[data-helix-pct]');
  const ticksEl = document.querySelector('[data-helix-ticks]');
  const now     = document.querySelector('[data-helix-now]');
  const title   = document.querySelector('[data-helix-title]');
  const meta    = document.querySelector('[data-helix-meta]');
  if (!fill && !index && !ticksEl && !pct && !title) return;

  // build the tick scale from STEPS so the markup stays free of filler <li>s
  const ticks = [];
  if (ticksEl) {
    for (let i = 0; i < STEPS; i++) {
      const li = document.createElement('li');
      ticksEl.appendChild(li);
      ticks.push(li);
    }
  }

  let last = -1;
  let lastPct = -1;
  let queued = false;

  function apply() {
    queued = false;
    const rect = section.getBoundingClientRect();
    const runway = rect.height - window.innerHeight;
    const p = runway > 0 ? clamp(-rect.top / runway, 0, 1) : 0;

    if (fill) fill.style.height = (p * 100).toFixed(2) + '%';

    const whole = Math.round(p * 100);
    if (pct && whole !== lastPct) {
      lastPct = whole;
      pct.textContent = String(whole).padStart(3, '0');
    }

    const step = clamp(Math.floor(p * STEPS), 0, STEPS - 1);
    if (step !== last) {
      last = step;
      if (index) index.textContent = String(step + 1).padStart(2, '0');
      ticks.forEach((li, i) => {
        li.classList.toggle('is-active', i === step);
        li.classList.toggle('is-past', i < step);
      });
      if (title) title.textContent = PIECES[step][0];
      if (meta)  meta.textContent  = PIECES[step][1];
      // restart the swap animation: drop the class, flush layout, re-add it
      if (now) {
        now.classList.remove('is-swap');
        void now.offsetWidth;
        now.classList.add('is-swap');
      }
    }
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(apply);
  }

  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule);
  apply();

  addEventListener('pagehide', () => {
    removeEventListener('scroll', schedule);
    removeEventListener('resize', schedule);
  }, { once: true });
}

const clamp = (v, a, b) => Math.min(Math.max(v, a), b);
